var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF6019",
    fillOpacity: 0.09
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73913 14.6087L16 18.7826L22.2609 14.6087L16 10.4348L9.73913 14.6087Z",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2609 14.6087V21.5652C22.2609 21.9342 22.1143 22.2881 21.8534 22.549C21.5924 22.8099 21.2386 22.9565 20.8696 22.9565H11.1304C10.7614 22.9565 10.4076 22.8099 10.1466 22.549C9.88571 22.2881 9.73913 21.9342 9.73913 21.5652V14.6087",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73913 21.5654L13.913 17.3914",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.087 17.3914L22.2609 21.5654",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6957,
    height: 16.6957,
    fill: "white",
    transform: "translate(7.65217 8.34784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenIcon);
export default __webpack_public_path__ + "static/media/MailOpenIcon.118e1c70.svg";
export { ForwardRef as ReactComponent };